import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import modificationReducer from 'src/features/modification/redux/modificationSlice';
import accountReducer from '../features/account/accountSlice';
import panDetailsReducer from '../features/panDetailsForm/panDetailsFormSlice';
import personalDetailsReducer from '../features/personalDetailsForm/personalDetailsFormSlice';
import nomineeDetailsReducer from '../features/nomineeDetailsForm/nomineeDetailsFormSlice';
import emailReducer from '../features/emailForm/emailFormSlice';
import bankDetailsReducer from '../features/bankDetailsForm/bankDetailsFormSlice';
import digioReducer from '../features/digioForm/digioFormSlice';
import fnoActivationDataReducer from '../features/fnoActivationForm/fnoActivationFormSlice';
import bankDetailsReduce from '../features/bankDetailsForm/bankDetailsSlice';
import rootSaga from './rootSaga';

const SagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: {
    account: accountReducer,
    panDetails: panDetailsReducer,
    personalDetails: personalDetailsReducer,
    emailData: emailReducer,
    bankDetails: bankDetailsReducer,
    digioData: digioReducer,
    nomineeDetails: nomineeDetailsReducer,
    fnoActivationDetails: fnoActivationDataReducer,
    // TODO change to bankDetails and remove bankDetailsData
    bankDetailsData: bankDetailsReduce,
    modification: modificationReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    thunk: false,
    serializableCheck: false,
  }).prepend(SagaMiddleware),
});

SagaMiddleware.run(rootSaga);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
